module.exports = __webpack_public_path__ + "static/media/undraw_message_sent_1030.323f49ac.svg";